import {
    FETCH_ACCESS_DETAILS_FAILURE,
    FETCH_ACCESS_DETAILS_REQUEST,
    FETCH_ACCESS_DETAILS_SUCCESS,
    FETCH_ACCESS_INFO_FAILURE,
    FETCH_ACCESS_INFO_REQUEST,
    FETCH_ACCESS_INFO_SUCCESS,
    NAVIGATE_ACCESS_DETAILS,
    NAVIGATE_ACCESS_INFO
} from './accessInfoAndDetails.actionsType';

export const ACCESS_INFO_AND_DETAILS = 'accessInfoAndDetails';

let initialState = {
    loading: false,
    AccessInfo: [],
    AccessDetails: [],
    AccessInfoId: null,
    userform: {},
    isAccessInfo: false,
    errorMessage: '',
    iperrorMessage: ''
};

export let accessInfoAndDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESS_INFO_REQUEST:
        case FETCH_ACCESS_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESS_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                AccessInfo: updatePayload
            };
        case FETCH_ACCESS_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                AccessDetails: updatePayload
            };
        case FETCH_ACCESS_INFO_FAILURE:
        case FETCH_ACCESS_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case NAVIGATE_ACCESS_DETAILS:
            return {
                ...state,
                isAccessInfo: true,
                AccessInfoId: updatePayload.userAccessId
            };
        case NAVIGATE_ACCESS_INFO:
            return {
                ...state,
                isAccessInfo: false
            };
        default:
            return state;
    }
};
